import { render } from "./AlertRuleForm.vue?vue&type=template&id=bb7939fc&ts=true"
import script from "./AlertRuleForm.vue?vue&type=script&lang=ts"
export * from "./AlertRuleForm.vue?vue&type=script&lang=ts"

import "./AlertRuleForm.vue?vue&type=style&index=0&id=bb7939fc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__